"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _ramda = require("ramda");

var _card_component = require("./global_components/card_component");

var _card_component2 = _interopRequireDefault(_card_component);

var _sanitize_utility = require("../../../packages/common-utilities/src/sanitize_utility.js");

var _sanitize_utility2 = _interopRequireDefault(_sanitize_utility);

var _string_utility = require("../../../packages/common-utilities/src/string_utility.js");

var _string_utility2 = _interopRequireDefault(_string_utility);

var _functional_utility = require("../../../packages/common-utilities/src/functional_utility");

var _reactIntl = require("react-intl");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var DistributorTableComponent = function (_React$PureComponent) {
  _inherits(DistributorTableComponent, _React$PureComponent);

  function DistributorTableComponent(props) {
    _classCallCheck(this, DistributorTableComponent);

    var _this = _possibleConstructorReturn(this, (DistributorTableComponent.__proto__ || Object.getPrototypeOf(DistributorTableComponent)).call(this, props));

    _this.renderData = _this.renderData.bind(_this);
    return _this;
  }

  _createClass(DistributorTableComponent, [{
    key: "renderPrintDisclosures",
    value: function renderPrintDisclosures() {
      return _react2.default.createElement(
        "div",
        { "data-testid": "print-disclosures", className: "print-display", style: { "display": "none" } },
        this.props.disclosure && _react2.default.createElement("div", { className: "font-slate-grey disclosure disclaimer print-page-break margin-bottom-15 text-justified",
          dangerouslySetInnerHTML: { __html: _sanitize_utility2.default.runSanitizer(this.props.disclosure) } })
      );
    }
  }, {
    key: "renderRow",
    value: function renderRow(data) {
      var markupArr = [];
      for (var i = 0; i < data.length; i++) {
        var row = [];
        for (var j = 0; j < data[i].length; j++) {
          var index = i * 3 + j;
          row.push(_react2.default.createElement(
            "div",
            { key: "distributor-column-" + index, "data-testid": "distributor-column-" + index,
              className: "display-inline-block width-percent-33 text-top padding-horizontal-10 padding-vertical-3 height-auto min-height-27" },
            _react2.default.createElement(
              "span",
              { className: "" },
              data[i][j]
            )
          ));
        }
        markupArr.push(_react2.default.createElement(
          "div",
          { "data-testid": "distributor-row-" + i, key: "distributor-row-" + i, className: "category row-divider" },
          row
        ));
      }
      return markupArr;
    }
  }, {
    key: "renderOneColumnPerRow",
    value: function renderOneColumnPerRow(data) {
      var row = [];
      for (var i = 0; i < data.length; i++) {
        row.push(_react2.default.createElement(
          "div",
          { key: "distributor-row-" + i, "data-testid": "distributor-row-" + i,
            className: "display-inline-block width-percent-100 padding-horizontal-10 padding-vertical-3 height-auto min-height-27 category row-divider" },
          _react2.default.createElement(
            "span",
            { className: "" },
            data[i]
          )
        ));
      }
      return row;
    }
  }, {
    key: "renderData",
    value: function renderData() {
      var data = this.props.data;
      if (data.length < 2 || this.props.breakpoint < 3) {
        return _react2.default.createElement(
          "div",
          { "data-testid": "one-col-layout", className: "caption font-light" },
          _react2.default.createElement(
            "div",
            null,
            this.renderOneColumnPerRow(data)
          )
        );
      }

      var dataArr = this.chunkArray(data);
      return _react2.default.createElement(
        "div",
        { "data-testid": "three-col-layout", className: "caption font-light" },
        this.renderRow(dataArr)
      );
    }
  }, {
    key: "chunkArray",
    value: function chunkArray(data) {
      var distributorAry = data.slice(0);
      var chunkSize = Math.ceil(distributorAry.length / 3);
      var outputArray = [];

      for (var i = 0; distributorAry.length < 3 * chunkSize; i++) {
        distributorAry.push(" ");
      }

      var rowSize = distributorAry.length / 3;

      for (var rowIndex = 0; rowIndex < rowSize; rowIndex++) {
        var row = [];
        for (var colIndex = 0; colIndex < 3; colIndex++) {
          row.push(distributorAry[rowIndex + colIndex * chunkSize]);
        }
        outputArray.push(row);
      }

      return outputArray;
    }
  }, {
    key: "render",
    value: function render() {
      if ((0, _ramda.isNil)(this.props.data) || (0, _functional_utility.isDataEmpty)(this.props.data)) {
        return null;
      }

      return _react2.default.createElement(
        _card_component2.default,
        {
          dataTest: "fund-distributor-card",
          headerTitle: _string_utility2.default.renderFormattedLabel("Distributor", this.props.headerTitleKey),
          headerTitleId: this.props.headerTitleId,
          breakpoint: this.props.breakpoint,
          disclosureText: this.props.disclosure,
          placementId: 'pdpCardRegisteredCountries',
          hideDisclosureinCardForPrintView: true
        },
        this.renderData(),
        _react2.default.createElement(
          "div",
          { "data-testid": "distributor-comp-print-disclosure" },
          this.renderPrintDisclosures()
        )
      );
    }
  }]);

  return DistributorTableComponent;
}(_react2.default.PureComponent);

exports.default = (0, _reactIntl.injectIntl)(DistributorTableComponent, { withRef: true });